export default __webpack_public_path__ + "static/media/more-options.c1f3ea9f.svg";